import React from 'react';
import "./TournamentHistory.css"
import TournamentFilter from "./TournamentFilter";
import * as actions from '../../store/actions/index';
import { connect } from 'react-redux';
import FontAwesome from 'react-fontawesome';
import { apiService } from '../../common/apiCallService.js'
import Loading from '../Loading';
import { domain, baseUrl } from "../../common/config.js"
import TournamentHistoryTable from './TournamentHistoryTable';
import i18next from 'i18next'
class TournamentHistoryMobile extends React.Component {
    constructor(props) {
        super(props);
        let { buyIn, gameSubType, trnyType, gameSpeed, dateRange, feedGameType } = this.props.activeTournyFilter
        this.state = {
            loading: false,
            tournamentAggResult: {},
            tournamentFeed: [],
            pageNumber: 0,
            trnyType: props.tournamentTypeList.length > 0 ? props.tournamentTypeList[0].value : null,
            gameSpeed: props.tournamentSpeedList.length > 0 ? props.tournamentSpeedList[0].value : null,
            buyIn, gameSubType, trnyType, gameSpeed, dateRange, feedGameType: this.props.myStatSettings.gameType === 'tournament' ? 'MTT' : this.props.myStatSettings.gameType,
            tournamentTypeList: props.tournamentTypeList,
            tournamentSpeedList: props.tournamentSpeedList
        }
    }

    nextPage = (data) => {
        this.setState({ pageNumber: data.selected })
        this.getHandHistory(data.selected)
    }

    componentWillReceiveProps(prevProps, prevState) {
        let mysatsGame = this.props.myStatSettings.gameType === 'tournament' ? 'MTT' : this.props.myStatSettings.gameType
        if (mysatsGame != this.state.feedGameType) {
            let { buyIn, gameSubType, trnyType, gameSpeed, dateRange, feedGameType } = prevProps.activeTournyFilter
            this.setState({
                tournamentAggResult: prevProps.tournyDtls.aggResult.length > 0 && prevProps.tournyDtls.aggResult[0],
                tournamentFeed: prevProps.tournyDtls.tournyDtls.length > 0 && prevProps.tournyDtls.tournyDtls,
                pageNumber: 0,
                buyIn, gameSubType, trnyType, gameSpeed, dateRange, feedGameType: this.props.myStatSettings.gameType === 'tournament' ? 'MTT' : this.props.myStatSettings.gameType,
                trnyType: prevProps.tournamentTypeList.length > 0 ? prevProps.tournamentTypeList[0].value : null,
                gameSpeed: prevProps.tournamentSpeedList.length > 0 ? prevProps.tournamentSpeedList[0].value : null,
                tournamentTypeList: prevProps.tournamentTypeList,
                tournamentSpeedList: prevProps.tournamentSpeedList
            })
        }
    }

    componentDidMount() {
        if (this.props.tournamentHistoryFullScreenFlag)
            this.setState({ tournamentAggResult: this.props.tournamentAggResult, tournamentFeed: this.props.tournamentFeed })
        else
            this.setState({
                tournamentAggResult: this.props.tournyDtls.aggResult.length > 0 && this.props.tournyDtls.aggResult[0],
                tournamentFeed: this.props.tournyDtls.tournyDtls.length > 0 && this.props.tournyDtls.tournyDtls
            })
    }

    getHandHistory = (pageNumber) => {
        this.setState({ loading: true, pageNumber: pageNumber })
        let { gameSubType, feedGameType, trnyType, buyIn, gameSpeed, dateRange } = this.state
        apiService(baseUrl + '/tournamentFeed/getTournamentFeedDtls', {
            accountName: localStorage.getItem('accountName'),
            limit: 5, offset: 5 * pageNumber,
            gameSubType, feedGameType, trnyType, buyIn, gameSpeed, dateRange, pageNumber
        }, (data) => {
            if (this.state.pageNumber === 0) {
                this.setState({ tournamentAggResult: data.aggResult.length > 0 && data.aggResult[0], tournamentFeed: data.tournyDtls.length > 0 && data.tournyDtls, loading: false })
            } else {
                this.setState({ tournamentFeed: data.tournyDtls.length > 0 && data.tournyDtls, loading: false })
            }
            document.body.scrollTop = document.documentElement.scrollTop = 0;
        }, (data) => {
            this.setState({ loading: false })
        })

    }

    toggleOpenDetails = () => {
        this.props.toggleTournamentHistoryDetails(!this.props.tournamentHistoryFlag)
    }

    toggleFullScreen = () => {
        this.props.toggleTournamentHistoryFullScreen(!this.props.tournamentHistoryFullScreenFlag)
    }

    saveSetting = (data) => {
        data.feedGameType = this.state.feedGameType
        this.props.setTournyFilter(data)
        this.setState({ pageNumber: 0 })
        this.setState(data, () => this.getHandHistory(0))
    }

    render() {
        let { tournamentTypeList, tournamentSpeedList } = this.props,
            { tournyPlayed, totalBountyWon, totalfee, totalBuyin } = this.state.tournamentAggResult
        return (
            <div>
                {(this.props.loading || this.state.loading)
                    ? <Loading />
                    :
                    <div className="ms_feed_cards_wrapper " >
                        <div>
                            <div className="tournamentHeader p-bottom-10-tournament">{i18next.t("lable.tournamentHistory")}
                        {!this.props.tournamentHistoryFullScreenFlag ? <span className="tournamentIconSpan">
                                    <i data-toggle="modal" data-target="#settingModalTournaments" className="fa fa-filter tournamentColor"></i>

                                    <i onClick={this.toggleFullScreen} className="tournamentColor marginLeftIconTornament fa fa-arrows-alt" ></i></span>
                                    : <span className="tournamentIconSpan">
                                        <button className='crossButton-tournament' data-toggle="modal" data-target="#settingModalTournaments" >
                                            <FontAwesome className='centre' name='fa fa-filter' style={{ fontSize: '2.5vh', color: 'white' }} />
                                        </button>
                                        <button className='crossButton-tournament' onClick={this.toggleFullScreen} >
                                            <FontAwesome className='centre' name='fas fa-times' style={{ fontSize: '2.5vh', color: 'white' }} />
                                        </button>
                                    </span>}
                            </div>
                            <div className="p-bottom-10-tournament tournament-font-size"><span className="tournamentSubHeaderSpan">{i18next.t("lable.total")} - </span> {i18next.t("lable.tournamentsPlayed")}: {tournyPlayed} - {i18next.t("lable.buyIns")}:${totalBuyin} </div>
                        </div>
                        <div className="border-bottom-tournamnet"></div>
                        <div>

                        </div>
                        <TournamentHistoryTable
                            nextPage={this.nextPage}
                            pageNumber={this.state.pageNumber}
                            openTournyDtls={this.props.openTournyDtls}
                            tournamentAggResult={this.state.tournamentAggResult}
                            tournamentFeed={this.state.tournamentFeed}
                            isFullScreen={false} />
                        <TournamentFilter
                            buyIn={this.state.buyIn}
                            feedGameType={this.state.feedGameType}
                            gameSubType={this.state.gameSubType}
                            trnyType={this.props.tournamentTypeList.length > 0 ? this.props.tournamentTypeList[0].value : ""}
                            gameSpeed={this.props.tournamentSpeedList.length > 0 ? this.props.tournamentSpeedList[0].value : ""}
                            dateRange={this.state.dateRange}
                            tournamentTypeList={this.props.tournamentTypeList}
                            saveSetting={this.saveSetting}
                            tournamentSpeedList={this.props.tournamentSpeedList}
                        />
                    </div>}
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        tournamentHistoryFlag: state.multipleReportCards.tournamentHistoryFlag,
        tournamentHistoryFullScreenFlag: state.multipleReportCards.tournamentHistoryFullScreenFlag,
        activeTournyFilter: state.multipleReportCards.activeTournyFilter,
        myStatSettings: state.multipleReportCards.myStatSettings,
        lang: state.header.lang
    };
};

const mapDispatchToProps = dispatch => {
    return {
        toggleTournamentHistoryDetails: (data) => dispatch(actions.toggleTournamentHistoryDetails(data)),
        toggleTournamentHistoryFullScreen: (data) => dispatch(actions.toggleTournamentHistoryFullScreen(data)),
        setTournyFilter: (data) => dispatch(actions.setTournyFilter(data))

    }
};

export default connect(mapStateToProps, mapDispatchToProps)(TournamentHistoryMobile);



/** WEBPACK FOOTER **
 ** ./src/components/MyStatistics/TournamentHistoryMobile.js
 **/